<template>
  <section :id="$options.name" class="info" v-if="details.description.important_information">
    <h2 class=" info__title">Da sapere</h2>
    <div class="info__text">
      <span v-html="details.description.important_information.it.replaceAll('.', '.<br>')" />
      <div class="info__license" v-if="license_numbers.length">
        <span class="info__license-title">Numero di licenza: </span>
        <span
          class="info__license-number"
          v-for="(license, license_index) in visible_licenses"
          :key="_uid+license_index"
        >
          {{ license }}
        </span>
      </div>
      <span
        v-if="license_numbers.length > 5"
        v-b-modal="'modal_license'"
        class="info__license-number-more"
      >
        vedi tutte
      </span>
      <vb-modal
        :vb_options="{
          id: 'modal_license',
          title: 'Numeri di licenza',
          size: 'md',
          centered: true,
          hide_footer: true
        }"
      >
        <div v-for="(license, license_index) in license_numbers" :key="_uid+license_index">
          <span>{{ license }}</span>
        </div>
      </vb-modal>
    </div>
    <key-info class="info__key" :hotel="details"/>
  </section>
</template>

<script>
import KeyInfo from '@bookingv3/components/blocks/key-info'

export default {
  inheritAttrs: false,
  name: 'info',

  components: {
    'key-info': KeyInfo,
  },

  props: {
    details: Object,
  },

  data() {
    return {
    }
  },

  computed: {
    license_numbers() {
      return this.details.description.license_numbers || []
    },
    visible_licenses() {
      return this.license_numbers.slice(0, 5)
    },
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .info {
    @extend %section;
    @extend %section_margin;

    &__title {
      @extend %section__title;
    }

    &__text {
      background-color: #fafcff;
      border-radius: 10px;
      margin-bottom: 0;
      padding: 20px;

      @include media-breakpoint-up(xl){
        line-height: $font-size-base * 2;
      }
    }

    &__license {
      font-size: $font-size-md;
      margin-top: 5px;

      &-title {
        font-weight: $vb-font-weight-semibold;
        margin-right: 5px;
      }

      &-number {
        margin-right: $grid-gutter-width / 6;

        &-more {
          color: $info;
          cursor: pointer;
          text-decoration: underline;
          font-size: $font-size-md;
        }
      }
    }

    &__key {
      @extend .info__text;
      margin-top: $grid-gutter-width;
    }
  }

</style>